import React, { type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import Html from 'common-translations/src/vtj/html/Html.react'
import type { TOptions } from 'i18next'
import { Paragraph as SuomifiUiParagraph } from 'suomifi-ui-components'

interface LocalizedStringProps {
  stringKey: string
  values?: TOptions
}

const LocalizedString = ({
  stringKey,
  values,
}: LocalizedStringProps): ReactElement => {
  const { t } = useTranslation()
  const options: TOptions = values || {}
  const translation = t(stringKey, options)

  const final = <Html key={translation} html={translation} />
  return <React.Fragment>{final}</React.Fragment>
}
export default LocalizedString

export type LocalizedParagraphsStringKey = `${string}_paragraphs`
/**
 * Double newline "\n\n" in translation is mapped to paragraph change.
 */
export const LocalizedParagraphs: React.FC<{
  stringKey: LocalizedParagraphsStringKey
  values?: TOptions
  Paragraph?: React.ComponentType
}> = ({ stringKey, values = {}, Paragraph = SuomifiUiParagraph }) => {
  const { t } = useTranslation()
  return (
    <>
      {t(stringKey, values)
        .split(/\n\n+/)
        .map((text, index) =>
          /\S/.test(text) ? (
            <Paragraph key={index}>
              <Html html={text} />
            </Paragraph>
          ) : null
        )}
    </>
  )
}
